import clsx from 'clsx';
import * as React from 'react';
import useStyles from './Badge.styles';

export interface IBadgeProps {
  type: 'error' | 'success';
}

const Badge: React.FC<React.PropsWithChildren<IBadgeProps>> = ({
  type,
  children,
}) => {
  const classes = useStyles();

  return (
    <div
      className={clsx(classes.root, {
        [classes.success]: type === 'success',
        [classes.error]: type === 'error',
      })}
    >
      {children}
    </div>
  );
};

export default Badge;
